import moment from 'moment';
import {
  CONFIRM_CUSTOM_TIME_RANGE,
  ON_DASHBOARD_TIME_FILTER_CHANGE,
  ON_DASHBOARD_CUSTOM_TIME_CHOSEN,
  ON_DASHBOARD_CUSTOM_TIME_FOCUS_CHANGE
} from '../actions.js';

const initialState = {
  selectedTime: 'mtd',
  tempTimeRange: {
    startDate: moment().subtract(1, 'month'),
    endDate: moment()
  },
  customTimeRange: {
    startDate: moment().subtract(1, 'month'),
    endDate: moment()
  },
  focusedInput: 'startDate'
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CONFIRM_CUSTOM_TIME_RANGE:
      return Object.assign({}, state, {
        customTimeRange: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate
        }
      });
    case ON_DASHBOARD_TIME_FILTER_CHANGE:
      return Object.assign({}, state, {
        selectedTime: action.payload
      });

    case ON_DASHBOARD_CUSTOM_TIME_CHOSEN:
      return Object.assign({}, state, {
        tempTimeRange: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate || action.payload.startDate
        }
      });

    case ON_DASHBOARD_CUSTOM_TIME_FOCUS_CHANGE:
      return Object.assign({}, state, {
        focusedInput: action.payload
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/selected-time.js